import { render, staticRenderFns } from "./Framework.vue?vue&type=template&id=158cd3b3&scoped=true"
var script = {}
import style0 from "./Framework.vue?vue&type=style&index=0&id=158cd3b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158cd3b3",
  null
  
)

export default component.exports